import React from "react";
import SaveFarmCard from "./SaveShareButtons";
import OperatingHours from "./OperatingHours";
import WeatherInfo from "./WeatherInfo";
import SideBarStyle from "../../../assets/stylesheets/farm-detail/sections/SideBar.module.css";
import Logger from "../../../utils/logger";

// const log = Logger.create('SidebarInfo');

export default function FarmSidebarInfo({ hours, coords }) {

  return (
    <aside className={SideBarStyle["sidebar-section"]}>
      {/* <SaveFarmCard /> */}
      <OperatingHours  hours={hours}/>
      <WeatherInfo coords={coords} />
    </aside>
  );
}
